import Papa from 'papaparse';

export const parseCSVForPreview = (file: File, onComplete: (rowCount: number, columns: string[], previewData: Record<string, unknown>[]) => void, onError: (error: unknown) => void): void => {
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results: Papa.ParseResult<Record<string, unknown>>) => {
      onComplete(results.data.length, results.meta.fields || [], results.data.slice(0, 5));
    },
    error: (error: unknown) => {
      onError(error);
    }
  });
};

export const getSuggestedIdentifierColumn = (columns: string[]) => {
  const URL_KEYWORDS = ['url', 'website', 'link'];
  const identifierColumn = columns.find(column => URL_KEYWORDS.some(word => column.trim().toLowerCase() === word)) || columns[0];
  return identifierColumn;
}
